module.exports = __webpack_public_path__ + "media/images/pays-white-c3d82bcbdeba90d7ec2d0b5244e9dba6.jpeg";